function isSessionAnonymised(value) {
  const pattern = /^\*+$/;
  return pattern.test(value);
}

export default isSessionAnonymised;
